{
  "tabs": {
    "chat": "Chat",
    "reminders": "Promemoria",
    "calendar": "Calendario",
    "settings": "Impostazioni"
  },
  "common": {
    "cancel": "Annulla",
    "save": "Salva",
    "confirm": "Conferma",
    "delete": "Elimina",
    "back": "Indietro",
    "close": "Chiudi",
    "edit": "Modifica",
    "search": "Cerca",
    "all": "Tutti",
    "loading": "Caricamento...",
    "error": "Si è verificato un errore",
    "notFound": "Non trovato",
    "tryAgain": "Riprova",
    "retry": "Riprova",
    "undo": "Annulla",
    "pullToRefresh": "Tira per aggiornare",
    "justNow": "proprio ora"
  },
  "auth": {
    "welcome": "Benvenuto in FishMemory",
    "tagline": "Il tuo assistente promemoria WhatsApp, ora in tasca.",
    "subtitle": "Il tuo assistente promemoria WhatsApp, ora in tasca.",
    "phoneLabel": "Il tuo numero WhatsApp",
    "phoneHint": "Invieremo un codice di verifica via WhatsApp",
    "invalidPhone": "Inserisci un numero di telefono valido",
    "continue": "Continua",
    "enterPhone": "Inserisci il tuo numero WhatsApp",
    "phonePlaceholder": "Numero di telefono",
    "sendCode": "Invia codice",
    "verifyTitle": "Verifica il tuo numero",
    "otpSentTo": "Un codice a 6 cifre è stato inviato a {{phone}} via WhatsApp",
    "enterFullCode": "Inserisci tutte le 6 cifre",
    "invalidOtp": "Codice non valido. Riprova.",
    "otpFailed": "Invio codice fallito. Riprova.",
    "otpResent": "Codice reinviato",
    "resendIn": "Reinvia in {{seconds}}s",
    "resendCode": "Reinvia codice",
    "enterOtp": "Inserisci il codice inviato su WhatsApp",
    "verify": "Verifica",
    "resend": "Reinvia codice",
    "wrongNumber": "Numero errato?",
    "backToPhone": "Torna al numero",
    "editPhone": "Modifica numero",
    "error": "Errore",
    "setupTitle": "Configuriamo tutto",
    "setupSubtitle": "Potrai sempre modificare in Impostazioni",
    "namePlaceholder": "Il tuo nome",
    "letsGo": "Completa configurazione",
    "skipForNow": "Salta per ora"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Scrivi un messaggio...",
    "inputPlaceholder": "Scrivi un messaggio...",
    "typing": "FishMemory sta scrivendo...",
    "online": "Online",
    "connecting": "Connessione...",
    "reconnecting": "Riconnessione...",
    "offline": "Offline",
    "empty": "Inizia una conversazione",
    "emptyHint": "Crea promemoria, controlla il calendario o chiedi aiuto.",
    "emptyAction": "Invia un promemoria di esempio",
    "actions": "Azioni chat",
    "keep": "Conserva messaggi",
    "clearTitle": "Svuota chat",
    "clearConfirm": "Eliminare tutti i messaggi da questo dispositivo? Non si può annullare.",
    "clear": "Svuota chat",
    "optionSelected": "Selezionato: {{label}}",
    "sendingSelection": "Invio...",
    "connectionLost": "Riconnessione..."
  },
  "reminders": {
    "title": "I miei promemoria",
    "active": "Attivi",
    "today": "Oggi",
    "thisWeek": "Questa settimana",
    "history": "Cronologia",
    "items": "elementi",
    "emptyTitle": "Nessun promemoria",
    "emptySubtitle": "Creane uno in chat e apparirà qui.",
    "emptyAction": "Apri chat",
    "filterActive": "Attivi",
    "filterToday": "Oggi",
    "filterWeek": "Questa settimana",
    "filterHistory": "Cronologia",
    "emptyState": "Nessun promemoria. Inizia a chattare!",
    "swipeDone": "Fatto",
    "swipeSnooze": "Posticipa",
    "swipeDelete": "Elimina",
    "search": "Cerca promemoria...",
    "upcoming": "In arrivo",
    "completed": "Completati",
    "overdue": "Scaduti",
    "tomorrow": "Domani",
    "synced": "Sincronizzati {{value}}",
    "swipeHint": "Scorri un promemoria per altre azioni",
    "noResults": "Nessun promemoria corrisponde alla ricerca",
    "noResultsHint": "Prova un'altra parola chiave o cancella la ricerca",
    "deleteAllFailed": "Impossibile eliminare tutti i promemoria"
  },
  "calendar": {
    "title": "Calendario",
    "today": "Oggi",
    "tomorrow": "Domani",
    "completed": "fatto",
    "noEvents": "Nessun evento",
    "noEventsSubtitle": "Scegli una data per vedere promemoria ed eventi.",
    "googleEvent": "Google Calendar",
    "legendActive": "Attivi",
    "legendRecurring": "Ricorrenti",
    "legendDone": "Fatti",
    "legendGoogle": "Google",
    "previousMonth": "Mese precedente",
    "nextMonth": "Mese successivo",
    "previousYear": "Anno precedente",
    "nextYear": "Anno successivo",
    "goToToday": "Vai a oggi",
    "all": "Tutti",
    "active": "Attivi",
    "done": "Fatti",
    "paused": "In pausa"
  },
  "settings": {
    "title": "Impostazioni",
    "profile": "Profilo",
    "name": "Nome visualizzato",
    "enterName": "Inserisci il nome",
    "language": "Lingua",
    "uiLanguage": "Lingua app",
    "uiLanguageHelp": "Modifica solo l’interfaccia, etichette calendario e direzione layout su questo dispositivo.",
    "serverLanguage": "Lingua chat",
    "serverLanguageHelp": "Modifica la lingua delle risposte server e dei messaggi promemoria per il tuo account.",
    "timezone": "Fuso orario",
    "currentTimezone": "Fuso orario attuale",
    "timezoneHelp": "Tutti gli orari dei promemoria sono mostrati in questo fuso.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Salva fuso orario",
    "timezoneSaved": "Fuso orario aggiornato",
    "detect": "Rileva",
    "detectFailed": "Impossibile rilevare fuso orario",
    "autoDetect": "Rilevamento GPS automatico",
    "notifications": "Notifiche",
    "notificationsHelp": "I promemoria di follow-up gestiscono avvisi ripetuti dopo la consegna. I permessi notifiche sono gestiti nelle impostazioni telefono.",
    "pushEnabled": "Notifiche push",
    "autoDoneOnFire": "Segna automaticamente come fatto all’attivazione",
    "autoDoneOnFireDesc": "Se disattivato, i promemoria restano attivi finché non li completi.",
    "googleCalendar": "Google Calendar",
    "google": "Google Calendar",
    "googleConnected": "Connesso",
    "googleDisconnected": "Non connesso",
    "googleConnectedHelp": "I nuovi promemoria possono essere sincronizzati automaticamente con il calendario.",
    "googleDisconnectedHelp": "Connetti Google Calendar per mantenere promemoria ed eventi allineati.",
    "googleConnectFailed": "Connessione a Google Calendar fallita",
    "connected": "Connesso",
    "disconnected": "Non connesso",
    "connect": "Connetti",
    "disconnect": "Disconnetti",
    "autoSync": "Sincronizza nuovi promemoria",
    "autosync": "Sincronizza nuovi promemoria",
    "subscription": "Abbonamento",
    "trialUsed": "Prova: {{used}}/{{total}} usati",
    "trialStatus": "Prova disponibile",
    "activeStatus": "Abbonamento attivo",
    "expiredStatus": "Abbonamento scaduto",
    "unsubscribedStatus": "Non abbonato",
    "about": "Info",
    "version": "Versione",
    "logout": "Esci",
    "logoutTitle": "Esci",
    "logoutConfirm": "Sei sicuro di voler uscire?",
    "noName": "Nessun nome impostato",
    "serverConnection": "Connessione server",
    "serverUrl": "URL server",
    "serverEdit": "Modifica",
    "saveReconnect": "Salva e riconnetti",
    "resetDefault": "Ripristina predefinito",
    "invalidServerUrlTitle": "URL server non valido",
    "invalidServerUrlMessage": "Inserisci un URL server http o https valido, es. https://example.com",
    "uiLanguageChangeFailed": "Impossibile cambiare lingua app. Riprova.",
    "serverLanguageChangeFailed": "Impossibile cambiare lingua chat. Riprova.",
    "timezoneChangeFailed": "Impossibile cambiare fuso orario. Riprova.",
    "autoSyncChangeFailed": "Impossibile aggiornare sincronizzazione automatica. Riprova.",
    "nameChangeFailed": "Impossibile aggiornare nome visualizzato. Riprova.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Dettagli promemoria",
    "editTime": "Modifica orario",
    "rename": "Rinomina",
    "snooze": "Posticipa",
    "snooze15": "Posticipa 15 minuti",
    "pause": "Pausa",
    "pauseReminder": "Metti in pausa promemoria",
    "resume": "Riprendi",
    "resumeReminder": "Riprendi promemoria",
    "skip": "Salta prossimo",
    "skipOccurrence": "Salta questa occorrenza",
    "syncGoogle": "Sincronizza con Google",
    "delete": "Elimina",
    "deleteTitle": "Elimina promemoria",
    "deleteConfirm": "Questo promemoria sarà eliminato definitivamente.",
    "deleteRecurringTitle": "Elimina promemoria ricorrente",
    "deleteRecurringMessage": "Vuoi saltare questa occorrenza o eliminare tutta la serie?",
    "deleteThisOccurrence": "Salta questa occorrenza",
    "deleteEntireSeries": "Elimina tutta la serie",
    "done": "Fatto",
    "markDone": "Segna come fatto",
    "undo": "Ripristina",
    "undoPrompt": "Serve di nuovo attivo? Ripristinalo ora.",
    "recurring": "Ricorrente",
    "nextRun": "Prossima esecuzione",
    "oneTime": "Una volta",
    "pending": "In sospeso",
    "sent": "Inviato",
    "paused": "In pausa",
    "active": "Attivo",
    "snoozed": "Posticipato",
    "localTime": "Mostrato nel tuo orario locale",
    "recurrence": "Ricorrenza",
    "created": "Creato",
    "tags": "Tag",
    "fireCount": "Volte attivato",
    "actions": "Azioni",
    "none": "Nessuno",
    "snoozeFailed": "Impossibile posticipare promemoria",
    "pauseFailed": "Impossibile mettere in pausa promemoria",
    "resumeFailed": "Impossibile riprendere promemoria",
    "skipFailed": "Impossibile saltare promemoria",
    "doneFailed": "Impossibile segnare promemoria come fatto",
    "undoFailed": "Impossibile ripristinare stato promemoria",
    "deleteFailed": "Impossibile eliminare promemoria",
    "rescheduleTitle": "Riprogrammare?",
    "rescheduleMsg": "Questo promemoria è scaduto. Vuoi riprogrammarlo?",
    "reschedule15": "Tra 15 minuti",
    "reschedule60": "Tra 1 ora",
    "keepOverdue": "Lascia com’è"
  },
  "onboarding": {
    "slide1Title": "Benvenuto in FishMemory",
    "slide1Sub": "Il tuo assistente promemoria personale — alimentato da WhatsApp e fatto per la tua tasca.",
    "slide2Title": "Chatta naturalmente",
    "slide2Sub": "Scrivi i promemoria come pensi: \"Ricordami di chiamare mamma domani alle 15\" — ci pensiamo noi.",
    "slide3Title": "Non perdere mai nulla",
    "slide3Sub": "Ricevi notifiche puntuali, organizza con tag e tieni tutto sotto controllo.",
    "getStarted": "Inizia",
    "next": "Avanti",
    "firstReminderTitle": "Crea il tuo primo promemoria!",
    "firstReminderHint": "Prova a scrivere:",
    "firstReminderExample": "Ricordami di bere acqua domani alle 9",
    "gotIt": "Ho capito!",
    "notifRationaleTitle": "Rimani puntuale",
    "notifRationaleBody": "FishMemory ha bisogno delle notifiche per ricordarti in tempo. Riceverai avvisi solo per i promemoria creati.",
    "notifRationaleAllow": "Attiva notifiche",
    "notifRationaleLater": "Forse dopo",
    "swipeHint": "Scorri a destra per azioni rapide →",
    "calendarDragHint": "Trascina per espandere ↕"
  }
}
